import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getToken } from '../api/auth/auth';

export default function PublicOnlyRoute(): React.ReactElement {
  const token = getToken();
  if (token) return <Navigate to="/admin" replace />;
  return <Outlet />;
}
